import React, { useState, useEffect } from 'react';
import { useI18n } from '../../hooks/useI18n';
import { client } from '../../api/client';

const DownloadIcon = ({ width = 24, height = 24 }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
    <polyline points="7 10 12 15 17 10"></polyline>
    <line x1="12" y1="15" x2="12" y2="3"></line>
  </svg>
);

const CloseIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);

const GlobeIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="2" y1="12" x2="22" y2="12"></line>
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
  </svg>
);

const ChevronDownIcon = ({ width = 16, height = 16 }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9"></polyline>
  </svg>
);

const ChevronUpIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="18 15 12 9 6 15"></polyline>
  </svg>
);

const VdotsIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="5" r="1.5" fill="currentColor"></circle>
    <circle cx="12" cy="12" r="1.5" fill="currentColor"></circle>
    <circle cx="12" cy="19" r="1.5" fill="currentColor"></circle>
  </svg>
);

const HomePlusIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
    <line x1="12" y1="10" x2="12" y2="16"></line>
    <line x1="9" y1="13" x2="15" y2="13"></line>
  </svg>
);

const PlusIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </svg>
);

const IosShareIcon = ({ width = 14, height = 14 }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path>
    <polyline points="16 6 12 2 8 6"></polyline>
    <line x1="12" y1="2" x2="12" y2="15"></line>
  </svg>
);

const IosThreeDotsIcon = ({ width = 14, height = 14 }) => (
<svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.6779 5.63882C12.4979 5.81886 12.2537 5.92 11.9991 5.92C11.7445 5.92 11.5003 5.81886 11.3202 5.63882C11.1402 5.45879 11.0391 5.21461 11.0391 4.96C11.0391 4.70539 11.1402 4.46121 11.3202 4.28118C11.5003 4.10114 11.7445 4 11.9991 4C12.2537 4 12.4979 4.10114 12.6779 4.28118C12.8579 4.46121 12.9591 4.70539 12.9591 4.96C12.9591 5.21461 12.8579 5.45879 12.6779 5.63882Z" stroke="#361777" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.6779 12.6788C12.4979 12.8589 12.2537 12.96 11.9991 12.96C11.7445 12.96 11.5003 12.8589 11.3202 12.6788C11.1402 12.4988 11.0391 12.2546 11.0391 12C11.0391 11.7454 11.1402 11.5012 11.3202 11.3212C11.5003 11.1411 11.7445 11.04 11.9991 11.04C12.2537 11.04 12.4979 11.1411 12.6779 11.3212C12.8579 11.5012 12.9591 11.7454 12.9591 12C12.9591 12.2546 12.8579 12.4988 12.6779 12.6788Z" stroke="#361777" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.6779 19.7188C12.4979 19.8989 12.2537 20 11.9991 20C11.7445 20 11.5003 19.8989 11.3202 19.7188C11.1402 19.5388 11.0391 19.2946 11.0391 19.04C11.0391 18.7854 11.1402 18.5412 11.3202 18.3612C11.5003 18.1811 11.7445 18.08 11.9991 18.08C12.2537 18.08 12.4979 18.1811 12.6779 18.3612C12.8579 18.5412 12.9591 18.7854 12.9591 19.04C12.9591 19.2946 12.8579 19.5388 12.6779 19.7188Z" stroke="#361777" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
);

const PwaBadge: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <span className="pwa-badge">{children}</span>
);

const PwaRawIcon: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <span className="pwa-raw-icon">{children}</span>
);

export const PwaInstallBanner: React.FC<{ 
  className?: string;
  variant?: 'default' | 'mobile-inline';
  onExpandChange?: (expanded: boolean) => void;
}> = ({ className = '', variant = 'default', onExpandChange }) => {
  const { t } = useI18n();
  const [isDismissed, setIsDismissed] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [activeOs, setActiveOs] = useState<'ios' | 'android'>('ios');
  const [isPWA, setIsPWA] = useState(false);

  useEffect(() => {
    const syncToServer = async () => {
      const token = sessionStorage.getItem('cab_token');
      if (token && sessionStorage.getItem('pwa_push_scheduled_sent') !== 'true') {
        try {
          await client.post('/push/pwa-installed');
          sessionStorage.setItem('pwa_push_scheduled_sent', 'true');
        } catch (e) {
          console.error('PWA install tracking sync failed:', e);
        }
      }
    };

    const checkPWA = () => {
      const match = window.matchMedia('(display-mode: standalone)').matches;
      const navStandalone = ('standalone' in navigator) && (navigator as any).standalone;
      const localInstalled = localStorage.getItem('pwa_installed') === 'true';
      
      const isRunningAsPWA = match || navStandalone;
      
      if (isRunningAsPWA) {
        localStorage.setItem('pwa_installed', 'true');
        syncToServer();
      }
      
      setIsPWA(isRunningAsPWA || localInstalled);
    };
    
    checkPWA();

    const handleAppInstalled = () => {
      localStorage.setItem('pwa_installed', 'true');
      setIsPWA(true);
      syncToServer();
    };

    window.matchMedia('(display-mode: standalone)').addEventListener('change', checkPWA);
    window.addEventListener('appinstalled', handleAppInstalled);

    return () => {
      window.matchMedia('(display-mode: standalone)').removeEventListener('change', checkPWA);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem('pwa_banner_dismissed') === 'true') {
      setIsDismissed(true);
    }

    const ua = navigator.userAgent || navigator.vendor || (window as any).opera;
    if (/iPad|iPhone|iPod|Macintosh/.test(ua) && !('MSStream' in window)) {
      setActiveOs('ios');
    } else {
      setActiveOs('android');
    }
  }, []);

  const handleDismiss = () => {
    setIsDismissed(true);
    sessionStorage.setItem('pwa_banner_dismissed', 'true');
  };

  const toggleExpand = (val: boolean) => {
    setIsExpanded(val);
    if (onExpandChange) {
      onExpandChange(val);
    }
  };

  // If already installed or dismissed, hide entirely
  if (isPWA || isDismissed) {
    return null;
  }

  const renderContent = () => {
    if (activeOs === 'ios') {
      return (
        <div className="pwa-steps-grid">
          <div className="pwa-steps-col">
            <div className="pwa-browser-title">
              <GlobeIcon /> Safari
            </div>
            <ul className="pwa-ul">
              <li>{t('pwa_s_1')} <PwaBadge><VdotsIcon /></PwaBadge></li>
              <li>{t('pwa_s_2')} <br className="hide-on-desktop" /><PwaBadge><IosShareIcon /> {t('pwa_s_2_badge')}</PwaBadge></li>
              <li>{t('pwa_s_3')} <br className="hide-on-desktop" /><PwaBadge><HomePlusIcon /> {t('pwa_s_3_badge')}</PwaBadge></li>
              <li>{t('pwa_s_4')} <br className="hide-on-desktop" /><PwaBadge>{t('pwa_s_4_badge')}</PwaBadge> {t('pwa_s_4_end')}</li>
            </ul>
          </div>
          <div className="pwa-steps-col">
            <div className="pwa-browser-title">
              <GlobeIcon /> Chrome
            </div>
            <ul className="pwa-ul">
              <li>{t('pwa_ci_1')} <PwaBadge><DownloadIcon width={14} height={14} /></PwaBadge> <br className="hide-on-desktop" />{t('pwa_ci_1_mid')} <PwaBadge><ChevronDownIcon width={14} height={14} /> {t('pwa_ci_1_badge')}</PwaBadge></li>
              <li>{t('pwa_s_3')} <br className="hide-on-desktop" /><PwaBadge><HomePlusIcon /> {t('pwa_s_3_badge')}</PwaBadge></li>
              <li>{t('pwa_s_4')} <br className="hide-on-desktop" /><PwaBadge>{t('pwa_s_4_badge')}</PwaBadge> {t('pwa_s_4_end')}</li>
            </ul>
          </div>
        </div>
      );
    } else {
      return (
        <div className="pwa-steps-grid">
          <div className="pwa-steps-col">
            <div className="pwa-browser-title">
              <GlobeIcon /> Chrome
            </div>
            <ul className="pwa-ul">
              <li>{t('pwa_ca_1')} <PwaBadge><VdotsIcon /></PwaBadge> {t('pwa_ca_1_end')}</li>
              <li>{t('pwa_s_3')} <br className="hide-on-desktop" /><PwaBadge><HomePlusIcon /> {t('pwa_s_3_badge')}</PwaBadge></li>
              <li>{t('pwa_ca_3')} <PwaBadge><PlusIcon /> {t('pwa_ca_3_badge1')}</PwaBadge> <br className="hide-on-desktop" />{t('pwa_ca_3_mid')} <PwaBadge><PlusIcon /> {t('pwa_ca_3_badge2')}</PwaBadge></li>
            </ul>
          </div>
        </div>
      );
    }
  };

  return (
    <div className={`pwa-banner-container ${isExpanded ? 'is-expanded' : ''} ${className}`} data-tour="pwa-banner" style={{ zIndex: isExpanded && variant === 'default' ? 102 : 10 }}>
      {(!isExpanded || variant !== 'mobile-inline') && (
        <div className="pwa-banner" style={{ zIndex: isExpanded ? 102 : 51 }}>
          <div className="pwa-icon-box">
            <DownloadIcon />
          </div>
          <div className="pwa-text-content">
            <div className="pwa-title">{t('pwa_banner_title')}</div>
            <div className="pwa-subtitle" dangerouslySetInnerHTML={{ __html: t('pwa_banner_sub') }}></div>
            <button className="pwa-link" onClick={() => toggleExpand(!isExpanded)}>
              {t('pwa_banner_how')} {isExpanded ? <ChevronUpIcon /> : <ChevronDownIcon />}
            </button>
          </div>
          <button className="pwa-close" onClick={handleDismiss}>
            <CloseIcon />
          </button>
        </div>
      )}

      {isExpanded && variant === 'default' && (
        <>
          <div className="pwa-expanded-overlay" onClick={() => toggleExpand(false)}></div>
          <div className="pwa-expanded-card">
            <button className="pwa-back-btn" onClick={() => toggleExpand(false)}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '6px' }}>
                <polyline points="15 18 9 12 15 6"></polyline>
              </svg>
              {t('pwa_back')}
            </button>

            <h2 className="pwa-title-lg">{t('pwa_exp_title')}</h2>
            <p className="pwa-subtitle-lg" dangerouslySetInnerHTML={{ __html: t('pwa_exp_sub') }}></p>

            <div className="pwa-tabs">
              <button 
                className={`pwa-tab ${activeOs === 'ios' ? 'active' : ''}`}
                onClick={() => setActiveOs('ios')}
              >
                iPhone
              </button>
              <button 
                className={`pwa-tab ${activeOs === 'android' ? 'active' : ''}`}
                onClick={() => setActiveOs('android')}
              >
                Android
              </button>
            </div>

            {renderContent()}
          </div>
        </>
      )}

      {isExpanded && variant === 'mobile-inline' && (
        <div className="pwa-mobile-inline-container">
          <div className="pwa-mobile-inline-card">
            <button className="pwa-back-btn-inline" onClick={() => toggleExpand(false)}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '6px' }}>
                <polyline points="15 18 9 12 15 6"></polyline>
              </svg>
              {t('pwa_back')}
            </button>

            <h2 className="pwa-title-lg">{t('pwa_exp_title')}</h2>
            <p className="pwa-subtitle-lg" dangerouslySetInnerHTML={{ __html: t('pwa_exp_sub') }}></p>

            <div className="pwa-tabs">
              <button 
                className={`pwa-tab ${activeOs === 'ios' ? 'active' : ''}`}
                onClick={() => setActiveOs('ios')}
              >
                iPhone
              </button>
              <button 
                className={`pwa-tab ${activeOs === 'android' ? 'active' : ''}`}
                onClick={() => setActiveOs('android')}
              >
                Android
              </button>
            </div>

            {renderContent()}
          </div>
        </div>
      )}

      <style>{`
        .pwa-banner-container {
          position: relative;
          z-index: 40;
        }
        .pwa-banner {
          background: #E6D6FA;
          border-radius: 24px;
          padding: 16px 20px;
          margin-bottom: 24px;
          display: flex;
          align-items: flex-start;
          gap: 16px;
          position: relative;
          z-index: 51;
        }
        .pwa-icon-box {
          background: #FFFFFF;
          width: 48px;
          height: 48px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: var(--cab-violet);
          flex-shrink: 0;
        }
        .pwa-text-content {
          flex-grow: 1;
          padding-right: 24px;
        }
        .pwa-title {
          color: var(--cab-violet);
          font-weight: 700;
          font-size: 16px;
          margin-bottom: 4px;
        }
        .pwa-subtitle {
          color: var(--cab-body);
          font-size: 13px;
          line-height: 1.4;
          margin-bottom: 8px;
        }
        .pwa-link {
          background: none;
          border: none;
          color: var(--cab-violet);
          font-weight: 700;
          font-size: 14px;
          text-decoration: underline;
          display: flex;
          align-items: center;
          gap: 4px;
          cursor: pointer;
          padding: 0;
          font-family: inherit;
        }
        .pwa-close {
          background: none;
          border: none;
          color: var(--cab-note);
          cursor: pointer;
          padding: 4px;
          position: absolute;
          top: 16px;
          right: 16px;
        }

        /* Expanded Popup styling */
        .pwa-expanded-overlay {
          // position: fixed;
          // top: 0; left: 0; right: 0; bottom: 0;
          // background: transparent;
          // z-index: 100;
        }
        .pwa-expanded-card {
          position: absolute;
          top: calc(100% - 12px);
          left: 0;
          width: 100%;
          background: #FAF8FE;
          border-radius: 24px;
          padding: 32px 48px 60px;
          color: var(--cab-violet);
          z-index: 101;
          box-shadow: 0 10px 40px rgba(54, 23, 119, 0.12);
        }

        .pwa-back-btn {
          display: flex;
          align-items: center;
          background: none;
          border: none;
          color: var(--cab-note);
          font-size: 15px;
          font-weight: 500;
          cursor: pointer;
          padding: 0;
          margin-bottom: 20px;
          font-family: inherit;
        }

        .pwa-title-lg {
          font-size: 24px;
          font-weight: 700;
          color: #361777;
          margin: 0 0 8px 0;
        }
        .pwa-subtitle-lg {
          font-size: 15px;
          color: #57437E;
          margin: 0 0 24px 0;
        }
        .pwa-tabs {
          display: flex;
          background: #F4F2FA;
          border-radius: 100px;
          padding: 4px;
          margin-bottom: 24px;
          margin-top: 24px;
        }
        @media (min-width: 768px) {
          .pwa-tabs {
            display: inline-flex;
            width: 320px;
            margin-bottom: 48px;
          }
          .pwa-title-lg {
            font-size: 20px;
          }
          .pwa-subtitle-lg {
            font-size: 14px;
          }
        }
        .pwa-tab {
          flex: 1;
          padding: 10px 0;
          border-radius: 100px;
          border: none;
          background: transparent;
          color: var(--cab-body);
          font-weight: 500;
          font-size: 15px;
          cursor: pointer;
          font-family: inherit;
        }
        .pwa-tab.active {
          background: #E6D6FA;
          color: var(--cab-violet);
          font-weight: 600;
          box-shadow: 0 1px 2px rgba(0,0,0,0.05);
        }
        .pwa-steps-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 32px;
        }
        @media (min-width: 768px) {
          .pwa-steps-grid {
            grid-template-columns: 1fr 1fr;
          }
        }
        .pwa-browser-title {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 16px;
          color: var(--cab-violet);
        }
        .pwa-ul {
          margin: 0;
          padding-left: 0;
          list-style: none;
          display: flex;
          flex-direction: column;
          gap: 12px;
          font-size: 15px;
          line-height: 1.5;
          color: var(--cab-body);
        }
        .pwa-ul li {
          padding-left: 0;
          margin-bottom: 2px;
          line-height: 1.6;
        }

        .pwa-badge {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          background: #E6D6FA;
          color: var(--cab-violet);
          padding: 4px 10px;
          border-radius: 8px;
          font-weight: 600;
          font-size: 13px;
          vertical-align: middle;
          margin: 0 4px;
          line-height: 1.2;
        }
        .pwa-badge svg {
          flex-shrink: 0;
        }
        
        .pwa-raw-icon {
          display: inline-flex;
          align-items: center;
          color: var(--cab-violet);
          vertical-align: middle;
          margin: 0 4px;
        }

        /* Mobile inline variant styling */
        .pwa-mobile-inline-container {
          padding: 0;
          animation: fadeIn 0.3s ease;
        }
        .pwa-back-btn-inline {
          display: flex;
          align-items: center;
          background: none;
          border: none;
          color: var(--cab-note);
          font-size: 15px;
          font-weight: 500;
          cursor: pointer;
          padding: 0;
          margin-bottom: 16px;
          font-family: inherit;
        }
        .pwa-mobile-inline-card {
          background: #FAF8FE;
          border-radius: 20px;
          padding: 24px 20px;
          color: var(--cab-violet);
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(5px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @media (max-width: 1023px) {
          .pwa-expanded-card {
            border-radius: 20px;
            padding: 20px;
            position: fixed;
            top: auto;
            bottom: 0;
            left: 0;
            right: 0;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
            max-height: 90vh;
            overflow-y: auto;
          }
          .pwa-banner-container.is-expanded .pwa-banner {
            display: none !important;
          }
        }

        @media (min-width: 1024px) {
          .pwa-banner {
            align-items: center;
          }
          .pwa-text-content {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 4px;
          }
          .pwa-title {
            margin-bottom: 0;
            width: 100%;
          }
          .pwa-subtitle {
            margin-bottom: 0;
          }
          .pwa-link {
            margin-left: auto;
          }
          .pwa-back-btn {
            display: none;
          }
          .hide-on-desktop {
            display: none !important;
          }
        }
        @media (max-width: 1023px) {
          .pwa-banner-container.mobile-pt {
            padding-top: 16px;
          }
          .hide-on-mobile {
            display: none !important;
          }
        }
      `}</style>
    </div>
  );
};
